import PropTypes from "prop-types";
import typedAction from "data/util/typedAction";

const OverActions = {
    SHOW: "over/show",
    HIDE: "over/hide",
    EXTERNAL_NAV: typedAction("over/external-nav", {
        message: PropTypes.string.isRequired,
        title: PropTypes.string,
        callback: PropTypes.func,
        actions: PropTypes.array,
    }),
    APP_ALERT: typedAction("over/app-alert", {
        message: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.func, // a render callback
        ]).isRequired,
        title: PropTypes.string,
        callback: PropTypes.func,
        actions: PropTypes.array,
    }),
    BROWSER_OFFLINE: "over/browser-offline",
    ARMUS_UNREACHABLE: "over/armus-unreachable",
    API_UNREACHABLE: "over/api-unreachable",
    HTTP_UNAUTHORIZED: "over/http-unauthorized",
    HTTP_FORBIDDEN: "over/http-forbidden",
    HTTP_NOT_FOUND: "over/http-not-found",
};

export default OverActions;



// WEBPACK FOOTER //
// ./app/data/OverActions.js